import { render, staticRenderFns } from "./CancelChangeEmail.vue?vue&type=template&id=1f098c58&"
import script from "./CancelChangeEmail.vue?vue&type=script&lang=js&"
export * from "./CancelChangeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports